import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";

const firebaseConfig = require("./firebaseConfig.json");

firebase.initializeApp(firebaseConfig);

export default firebase;
